import { render, staticRenderFns } from "./VitalSignsSummary.vue?vue&type=template&id=b0732b2a&scoped=true"
import script from "./VitalSignsSummary.vue?vue&type=script&lang=js"
export * from "./VitalSignsSummary.vue?vue&type=script&lang=js"
import style0 from "./VitalSignsSummary.vue?vue&type=style&index=0&id=b0732b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0732b2a",
  null
  
)

export default component.exports